:global(html.video-landing-page) {
  background-color: #f8fafc;
}

.message_header {
  background-color: #e5e7eb90;
  backdrop-filter: blur(32px);
}

.message_body {
  min-height: calc(100vh - (8rem + 1rem) - (46px));

  a {
    text-decoration-line: underline;
    text-decoration-color: #0ea5e9;
    text-decoration-style: solid;

    &:hover {
      text-decoration-color: #3b82f6;
    }
  }
}

@keyframes typingBounce {
  0%,
  60%,
  100% {
    transform: translateY(0);
  }
  30% {
    transform: translateY(-4px);
  }
}

.typingIndicatorBubbleDot {
  width: 4px;
  height: 4px;
  margin-right: 4px;
  background-color: #57585a;
  border-radius: 50%;
  animation-name: typingBounce;
  animation-duration: 1.3s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
}

.typingIndicatorBubbleDot:first-of-type {
  margin: 0px 4px;
}

.typingIndicatorBubbleDot:nth-of-type(2) {
  animation-delay: 0.15s;
}

.typingIndicatorBubbleDot:nth-of-type(3) {
  animation-delay: 0.3s;
}
